<template>
  <div class="colorPreset">
    <div class="btnColorPicker" @click="colorPicker($event)">
      {{color}}
      <i :style="{backgroundColor: color}"></i>
    </div>
    <sketch-picker
      v-show="active"
      :value="color"
      @input="setColor" />
  </div>
</template>

<script>
import sketch from 'vue-color/src/components/Sketch.vue'

export default {
  name: 'ColorPicker',
  props: [
    'target',
    'color',
    'pointcolors',
    'useColorOnly' // store의 세팅으로 commit 필요없이 target, color 값만 전달
  ],
  components: {
    'sketch-picker': sketch
  },
  watch: {
    active (isActive) {
      if (isActive) {
        document.addEventListener('click', this.hideColorPicker)
      }
    }
  },
  data () {
    return {
      active: false
    }
  },
  methods: {
    setColor (c) {
      const pointcolors = this.pointcolors
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      const data = {
        target: this.target,
        color: rgba
      }
      if (this.useColorOnly) {
        this.$emit('changeColor', data)
      } else {
        this.$store.commit(pointcolors ? 'setting/setPointcolors' : 'setting/setColors', data)
        this.$emit('changeColor', rgba)
      }
    },
    colorPicker (e) {
      document.querySelectorAll('.colorPreset').forEach(x => {
        x.classList.remove('active')
      })
      document.querySelectorAll('.vc-sketch').forEach(x => {
        x.style.display = 'none'
      })
      e.currentTarget.closest('.colorPreset').classList.add('active')
      e.currentTarget.nextSibling.style.display = 'block'
      document.addEventListener('click', this.hideColorPicker)
    },
    hideColorPicker: function (e) {
      if (e.target.closest('.colorPreset') === null) {
        this.active = false
        document.querySelectorAll('.colorPreset').forEach(x => {
          x.classList.remove('active')
        })
        document.querySelectorAll('.vc-sketch').forEach(x => {
          x.style.display = 'none'
        })
        document.removeEventListener('click', this.hideColorPicker)
      }
    }
  }
}
</script>
